export  const departments = [
    {
        "department_number": 1,
        "department_name": "Computer Science",
        "discipline": "Engineering"
    },
    {
        "department_number": 2,
        "department_name": "Mechanical Engineering",
        "discipline": "Engineering"
    },
    {
        "department_number": 3,
        "department_name": "Civil Engineering",
        "discipline": "Engineering"
    },
    {
        "department_number": 4,
        "department_name": "Electrical Engineering",
        "discipline": "Engineering"
    },
    {
        "department_number": 5,
        "department_name": "Chemical Engineering",
        "discipline": "Engineering"
    },
    {
        "department_number": 6,
        "department_name": "Biomedical Engineering",
        "discipline": "Engineering"
    },
    {
        "department_number": 7,
        "department_name": "Aerospace Engineering",
        "discipline": "Engineering"
    },
    {
        "department_number": 8,
        "department_name": "Environmental Engineering",
        "discipline": "Engineering"
    },
    {
        "department_number": 9,
        "department_name": "Material Science",
        "discipline": "Engineering"
    },
    {
        "department_number": 10,
        "department_name": "Industrial Engineering",
        "discipline": "Engineering"
    },
    {
        "department_number": 11,
        "department_name": "Software Engineering",
        "discipline": "Engineering"
    },
    {
        "department_number": 12,
        "department_name": "Physics",
        "discipline": "Science"
    },
    {
        "department_number": 13,
        "department_name": "Chemistry",
        "discipline": "Science"
    },
    {
        "department_number": 14,
        "department_name": "Biology",
        "discipline": "Science"
    },
    {
        "department_number": 15,
        "department_name": "Mathematics",
        "discipline": "Science"
    },
    {
        "department_number": 16,
        "department_name": "Geology",
        "discipline": "Science"
    },
    {
        "department_number": 17,
        "department_name": "Astronomy",
        "discipline": "Science"
    },
    {
        "department_number": 18,
        "department_name": "Environmental Science",
        "discipline": "Science"
    },
    {
        "department_number": 19,
        "department_name": "Statistics",
        "discipline": "Science"
    },
    {
        "department_number": 20,
        "department_name": "Psychology",
        "discipline": "Social Sciences"
    },
    {
        "department_number": 21,
        "department_name": "Sociology",
        "discipline": "Social Sciences"
    },
    {
        "department_number": 22,
        "department_name": "Political Science",
        "discipline": "Social Sciences"
    },
    {
        "department_number": 23,
        "department_name": "Anthropology",
        "discipline": "Social Sciences"
    },
    {
        "department_number": 24,
        "department_name": "Economics",
        "discipline": "Social Sciences"
    },
    {
        "department_number": 25,
        "department_name": "History",
        "discipline": "Social Sciences"
    },
    {
        "department_number": 26,
        "department_name": "Geography",
        "discipline": "Social Sciences"
    },
    {
        "department_number": 27,
        "department_name": "Philosophy",
        "discipline": "Humanities"
    },
    {
        "department_number": 28,
        "department_name": "English",
        "discipline": "Humanities"
    },
    {
        "department_number": 29,
        "department_name": "Linguistics",
        "discipline": "Humanities"
    },
    {
        "department_number": 30,
        "department_name": "Art History",
        "discipline": "Humanities"
    },
    {
        "department_number": 31,
        "department_name": "Classics",
        "discipline": "Humanities"
    },
    {
        "department_number": 32,
        "department_name": "Music",
        "discipline": "Arts"
    },
    {
        "department_number": 33,
        "department_name": "Theater",
        "discipline": "Arts"
    },
    {
        "department_number": 34,
        "department_name": "Dance",
        "discipline": "Arts"
    },
    {
        "department_number": 35,
        "department_name": "Visual Arts",
        "discipline": "Arts"
    },
    {
        "department_number": 36,
        "department_name": "Film Studies",
        "discipline": "Arts"
    },
    {
        "department_number": 37,
        "department_name": "Graphic Design",
        "discipline": "Arts"
    },
    {
        "department_number": 38,
        "department_name": "Creative Writing",
        "discipline": "Arts"
    },
    {
        "department_number": 39,
        "department_name": "Education",
        "discipline": "Education"
    },
    {
        "department_number": 40,
        "department_name": "Curriculum and Instruction",
        "discipline": "Education"
    },
    {
        "department_number": 41,
        "department_name": "Educational Leadership",
        "discipline": "Education"
    },
    {
        "department_number": 42,
        "department_name": "Counselor Education",
        "discipline": "Education"
    },
    {
        "department_number": 43,
        "department_name": "Special Education",
        "discipline": "Education"
    },
    {
        "department_number": 44,
        "department_name": "Nursing",
        "discipline": "Health Sciences"
    },
    {
        "department_number": 45,
        "department_name": "Public Health",
        "discipline": "Health Sciences"
    },
    {
        "department_number": 46,
        "department_name": "Pharmacy",
        "discipline": "Health Sciences"
    },
    {
        "department_number": 47,
        "department_name": "Physical Therapy",
        "discipline": "Health Sciences"
    },
    {
        "department_number": 48,
        "department_name": "Occupational Therapy",
        "discipline": "Health Sciences"
    },
    {
        "department_number": 49,
        "department_name": "Nutrition",
        "discipline": "Health Sciences"
    },
    {
        "department_number": 50,
        "department_name": "Speech Pathology",
        "discipline": "Health Sciences"
    },
    {
        "department_number": 51,
        "department_name": "Business Administration",
        "discipline": "Business"
    },
    {
        "department_number": 52,
        "department_name": "Accounting",
        "discipline": "Business"
    },
    {
        "department_number": 53,
        "department_name": "Finance",
        "discipline": "Business"
    },
    {
        "department_number": 54,
        "department_name": "Marketing",
        "discipline": "Business"
    },
    {
        "department_number": 55,
        "department_name": "Management",
        "discipline": "Business"
    },
    {
        "department_number": 56,
        "department_name": "International Business",
        "discipline": "Business"
    },
    {
        "department_number": 57,
        "department_name": "Information Systems",
        "discipline": "Business"
    },
    {
        "department_number": 58,
        "department_name": "Supply Chain Management",
        "discipline": "Business"
    },
    {
        "department_number": 59,
        "department_name": "Entrepreneurship",
        "discipline": "Business"
    },
    {
        "department_number": 60,
        "department_name": "Hospitality Management",
        "discipline": "Business"
    }
]  